module.exports = __webpack_public_path__ + "img/index_map_place03.2a9ce55a.jpg";